/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Personsstrategisch1Inputs */

const de__field_personsstrategisch1 = /** @type {(inputs: _Field_Personsstrategisch1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Person Strategisch`)
};

/**

* @param {_Field_Personsstrategisch1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_personsstrategisch1 = /** @type {((inputs?: _Field_Personsstrategisch1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Personsstrategisch1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_personsstrategisch1(inputs)
});
export { _field_personsstrategisch1 as "_field_personsStrategisch" }